
import _ from 'lodash';
export const SAMPLE_QUESTIONS =
    {
        TOTAL_SPEND_ON_PLUMBING_FIXTURES_LAST_YEAR: {
            id: 'TOTAL_SPEND_ON_PLUMBING_FIXTURES_LAST_YEAR',
            display: 'What was the total Spend on Plumbing Fixtures last year',
            description: 'What was the total Spend on Plumbing Fixtures last year',
        },



        SHOW_ME_ELECTRICIANS_WITH_MORE_THAN_$1_MILLION_IN_ANNUAL_SALES_IN_THE_NORTHEAST: {
            id: 'SHOW_ME_ELECTRICIANS_WITH_MORE_THAN_$1_MILLION_IN_ANNUAL_SALES_IN_THE_NORTHEAST',
            display: '<b>Electricians</b> with more than <b> $1 million in Annual Sales</b> in the <b>Northeast</b>.',
            description: 'Show me electricians with more than $1 million in annual sales in the Northeast',
        },
        SHOW_ME_ALL_HVAC_CONTRACTORS_WITH_10_OR_MORE_TECHNICIANS_IN_OHIO: {
            id: 'SHOW_ME_ALL_HVAC_CONTRACTORS_WITH_10_OR_MORE_TECHNICIANS_IN_OHIO',
            display: 'Show me all HVAC contractors with 10 or more technicians in Ohio',
            description: 'Show me all HVAC contractors with 10 or more technicians in Ohio'
        },

        SHOW_ME_BY_TRADE_ALL_CONTRACTOR_IN_COLORADO: {
            id: 'SHOW_ME_BY_TRADE_ALL_CONTRACTOR_IN_COLORADO',
            display: 'Show me by <b>Trade</b>, all the contractors in <b>Colorado</b>',
            description: 'Show me by Trade, all the contractors in Colorado'
        },


        SHOW_ME_THE_TOTAL_SPEND_BY_PRODUCT_CATEGORY_IN_TEXAS: {
            id: 'SHOW_ME_BY_TRADE_ALL_CONTRACTOR_IN_COLORADO',
            display: ' Show me the total <b>Spend</b> by <b>Product Category</b> in <b>Texas</b>',
            description: ' Show me the total spend by product category in texas'
        },

        TOP_5_BUILDERS_IN_TEXAS_BASED_ON_REVIEWS: {
            id: 'TOP_5_BUILDERS_IN_TEXAS_BASED_ON_REVIEWS',
            display: 'Top 5 <b>Builders</b> in <b>Texas</b> based on <b>Reviews</b>',
            description: 'Top 5 Builders in Texas based on Reviews',
        },

        TOP_10_SPEND_ON_PLUMBING_FIXTURES: {
            id: 'TOP_10_SPEND_ON_PLUMBING_FIXTURES',
            display: 'Top 10 <b>Spenders</b> in <b>Plumbing</b>',
            description: 'Top 10 spenders in Plumbing',
        },
        SHOW_ME_COMPANIES_IN_AUSTIN_THAT_SPEND_OVER_10K_ON_LENNOX_LAST_YEAR: {
            id: 'SHOW_ME_COMPANIES_IN_AUSTIN_THAT_SPEND_OVER_10K_ON_LENNOX_LAST_YEAR',
            display: '<b>Companies</b> with <b> > $10K HVAC Spend </b> on <b>Lennon</b in <b> Austin, TX</b>',
            description: 'Companies with > $10K HVAC Spend on Lennon in Austin, TX',
        },
    }

    export function getSampleQuestionById(id) {
        if (id) {
            return _.get(SAMPLE_QUESTIONS, id);
        }
    }
